import React, { useState } from "react";
import { useDispatch } from "react-redux";
import newDashboard from "../../../../assets/Images/create-new-dashboard-img.svg";
import "./DashboardWelcomePage.css";
import { useGridStackContext } from "../../../../contexts/grid-stack-context";
import { ConfigurePanelDialog } from "../gridStack/panels/ConfigurePanelDialog/ConfigurePanelDialog";
import {
  queries,
  actions,
} from "../../../../redux/features/account/accountSlice";

const DashboardWelcomePage = ({
  stream,
  tabId,
  actions: actionsFromModule,
}) => {
  const { events } = useGridStackContext();
  const dispatch = useDispatch();
  const [configOpen, setConfigOpen] = useState(false);

  const handleOpenConfig = async () => {
    dispatch(actions.reset());
    dispatch(actions.setTabMetadata({ stream, tabId }));
    await dispatch(queries.getPanelInitialInfo());
    setConfigOpen(true);
    dispatch(queries.loadAllPredefinedPanels());
  };

  const handleCloseConfig = () => {
    console.log("Closing Configure Panel Dialog");
    setConfigOpen(false);
  };

  return (
    <>
      <section className="dashboard-welcome-page-container">
        <div>
          <img style={{ maxWidth: "500px" }} src={newDashboard} />
        </div>
        <div>
          <h2>Welcome to your workspace!</h2>
          <p>You don&apos;t have any Panel yet. Ready to get started? </p>
          <div className="dashboard-welcome-btn-container">
            <button className="predefined-panel" onClick={handleOpenConfig}>
              <span className="icon-add-new" />
              <p>Predefined Panel</p>
            </button>
            {/* <button className="new-panel" onClick={events.onCreateFirstPanel}>
              <span className="icon-add-new" />
              <p>New Panel</p>
            </button> */}
          </div>
        </div>
      </section>
      <ConfigurePanelDialog
        actions={actionsFromModule}
        isOpen={configOpen}
        onClose={handleCloseConfig}
      />
    </>
  );
};

export default DashboardWelcomePage;
